<template>
  <div>
    <div class="container-fluid">
      <div class="page-title">
        <div class="row">
          <div class="col-md-3">
            <h3 style="margin-top: -10px; margin-left: -30px;">{{ title }}</h3>

            <ol class="breadcrumb" style="justify-content:none; margin-left: -30px;">
              <li class="breadcrumb-item">
                <router-link :to="{ path: '/' }">Home</router-link>
              </li>
              <li class="breadcrumb-item" v-if="main">{{ main }}</li>
              <li class="breadcrumb-item active" v-if="title">{{ title }}</li>
            </ol>

          </div>

          <!-- Middle Part: Menu -->
          <div class="col-md-6 text-center">
            <div class="left-header col horizontal-wrapper pl-0">
              <ul class="horizontal-menu">
                <LevelCCP ref='ccp' @closeMenu="closeMenu('ccp')" />
                <LevelBeacon ref='beacon' @closeMenu="closeMenu('beacon')" />
                <LevelUser />
                <LevelQueue ref='queue' @closeMenu="closeMenu('queue')" />
                <LevelRules />
                <LevelSetting ref='setting' @closeMenu="closeMenu('setting')" />
              </ul>
            </div>
          </div>

          <!-- Right Part: Profile -->
          <div class="col-md-3 text-right">
            <ul class="nav-menus">
              <Profile />
            </ul>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import Profile from './header/profile_new';
import LevelBeacon from './navmenu_new/beacon';
import LevelCCP from './navmenu_new/ccp';
import LevelUser from './navmenu_new/user-management';
import LevelQueue from './navmenu_new/queue-management';
import LevelRules from './navmenu_new/rules-management';
import LevelSetting from './navmenu_new/setting';
export default {
  components: {
    Profile,
    LevelBeacon,
    LevelCCP,
    LevelUser,
    LevelQueue,
    LevelRules,
    LevelSetting,
  },
  props: {
    title: {
      default: 'home',
    },
    main: {
      default: '',
    },
  },
  methods: {
    closeMenu(componentName) {
      // Close all menus except the one specified
      Object.keys(this.$refs).forEach(refName => {
        if (refName !== componentName && this.$refs[refName].openLevelmenu) {
          this.$refs[refName].openLevelmenu = false;
        }
      });
    },

    // closeMenu(e) {
    //   if (e == 'ccp') {
    //     this.$refs.beacon.openLevelmenu = false
    //   } else {

    //     this.$refs.ccp.openLevelmenu = false
    //   }
    //   // console.log('close: ', e)
    // }
  }
};
</script>
